import {
	clear as tauriClear,
	readText as tauriReadText,
	writeText as tauriWriteText,
} from "@tauri-apps/plugin-clipboard-manager";

import { env } from "@moment/state";

/**
 * Write plain text to the clipboard.
 * Works in both Tauri desktop app and browser environments.
 */
export async function writeClipboardText(text: string): Promise<void> {
	if (env.isDesktopApp) {
		await tauriWriteText(text);
	} else {
		await navigator.clipboard.writeText(text);
	}
}

const TAURI_CLIPBOARD_EMPTY_ERROR =
	"The clipboard contents were not available in the requested format or the clipboard is empty.";

/**
 * Read plain text from the clipboard.
 * Works in both Tauri desktop app and browser environments.
 * Returns null if clipboard is empty or inaccessible.
 */
export async function readClipboardText(): Promise<string | null> {
	if (env.isDesktopApp) {
		try {
			return await tauriReadText();
		} catch (error) {
			// Yep, Tauri is throwing a string (not an error) when the clipboard is empty. Just
			// ignore it lol.
			if (error === TAURI_CLIPBOARD_EMPTY_ERROR) {
				return null;
			}

			// Clipboard access might be denied
			console.error("Failed to read from clipboard:", error);
			return null;
		}
	} else {
		try {
			return await navigator.clipboard.readText();
		} catch (error) {
			// Clipboard access might be denied
			console.error("Failed to read from clipboard:", error);
			return null;
		}
	}
}

/**
 * Clear the clipboard contents.
 * Works in both Tauri desktop app and browser environments.
 */
export async function clearClipboard(): Promise<void> {
	if (env.isDesktopApp) {
		await tauriClear();
	} else {
		await navigator.clipboard.writeText("");
	}
}
